'use client';

import type { FC } from 'react';
import { Button, Flex } from '@eqi-investimentos/react';
import { Slider } from '@eqi-investimentos/slider';
import { FlexProps, useDisclosure } from '@chakra-ui/react';
import { Icon } from '@/components/elements/Icon';
import { PDFPage } from './Page';
import '@eqi-investimentos/slider/css';

export const PDFSlider: FC<PDFSliderProps> = ({ pages }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <Flex sx={sliderSx} {...(isOpen ? modalProps : { position: 'relative' })}>
      <Slider
        id="pdf-slider"
        slidesPerView={1}
        displayControls
        progressType="fraction"
        controlsAlignment="center"
        swiperGap="0px"
      >
        {pages.map((page, idx) => (
          <PDFPage key={idx} page={page} />
        ))}
      </Slider>
      <Button
        onClick={isOpen ? onClose : onOpen}
        aria-label={isOpen ? 'Fechar modo tela cheia' : 'Abrir em tela cheia'}
        variant="naked"
        zIndex="overlay"
        pos="absolute"
        bottom="6rem"
        left="calc((50% - 2rem) + (min(100vw, 57rem) / 2) - 2.75rem)"
      >
        <Icon
          iconName={isOpen ? 'FullScreenExitOutline' : 'FullScreenOutline'}
          color="content.alwaysLight"
          w="2rem !important"
          h="2rem !important"
        />
      </Button>
    </Flex>
  );
};

const modalProps: FlexProps = {
  position: 'absolute',
  w: '100vw',
  h: '100vh',
  bg: 'background.alwaysDark',
  top: 0,
  left: 0,
  zIndex: 'modal',
};

const sliderSx = {
  '& .swiper-slide': {
    w: '100% !important',
  },
  '& .swiper-slide > div': {
    minH: '100%',
  },
  '& div:has(> .slide-pagination-pdf-slider)': {
    w: '57rem',
    justifyContent: 'space-between',
    alignSelf: 'center',
    bg: 'background.secondary',
    py: 'm',
    px: 'l',
  },
  '& .slide-pagination-pdf-slider': {
    bg: 'transparent',
    color: 'content.primary',
  },
};

type PDFSliderProps = {
  pages: string[];
};
